import _ from 'lodash';
import {
  getCookie,
  setCookie,
  getPaginatedStorage,
  setPaginatedStorage,
  removePaginatedStorage,
} from 'helpers/Storage';
import { callDelightedSurvey, initSegmentDeviceIdCookie } from '@foxcorp/delta-web-analytics';
import { addYears, now } from 'helpers/DateTimeHelper';
import v4 from 'uuid';

const generateCookie = (name, value, expires) => {
  const options = { name, value, options: { path: '/', expires } };
  setCookie(options);
};

export const ANONYMOUS_ACCOUNT_TYPE = 'anonymous';
const ANONYMOUS_ID_COOKIE = 'ajs_anonymous_id';
const ANONYMOUS_FAVORITES_STORAGE_NAME = _.get(
  window.ExternalConfig,
  'anonymousUser.favoritesCookie',
);
export const getAnonymousIdCookie = () => getCookie({ name: ANONYMOUS_ID_COOKIE });
export const initAnonymousId = () => {
  const anonymousIdCookie = getAnonymousIdCookie();
  let anonymousId = anonymousIdCookie || v4();
  anonymousId = anonymousId.replace(/"/g, '');
  const yearsToAdd = 1;
  const expires = addYears(now(), yearsToAdd);

  initSegmentDeviceIdCookie({ deviceId: anonymousId, expires, generateCookie });
  callDelightedSurvey(anonymousId);

  return anonymousId;
};

export function setAnonymousFavoritesInStorage({ anonymousFavorites }) {
  setPaginatedStorage({
    key: ANONYMOUS_FAVORITES_STORAGE_NAME,
    value: anonymousFavorites,
    options: { path: '/', limit: 10 },
  });
}

export const anonymousIdWatcher = () =>
  new Promise(resolve => {
    if (getAnonymousIdCookie()) return resolve(true);
    // 50 count x 50ms interval = 2.5 sec
    let counter = 0;
    const isLoaded = setInterval(() => {
      const id = getAnonymousIdCookie();
      if (counter > 50 || id) {
        clearInterval(isLoaded);
        resolve(true);
      } else {
        counter += 1;
      }
    }, 50);
    return false;
  });

export function getAnonymousFavoritesFromStorage() {
  return getPaginatedStorage({
    key: ANONYMOUS_FAVORITES_STORAGE_NAME,
  });
}

export function resetAnonymous(options) {
  const { copyFavoritesToAccount } = options || {};
  if (!copyFavoritesToAccount) return;
  removePaginatedStorage({ key: ANONYMOUS_FAVORITES_STORAGE_NAME });
}

export function isHiddenForAnonymous({ hideIfNotLoggedIn }) {
  return hideIfNotLoggedIn;
}

export async function getCurrentAccount({ account, anonymousAccount, anonymousLogin, deviceId }) {
  let newAnonymousAccount = {};

  if (!account && !anonymousAccount && deviceId) {
    try {
      const result = await anonymousLogin({
        deviceId,
      });
      newAnonymousAccount = result ? result.data : null;
      newAnonymousAccount.isNew = true;
    } catch (error) {
      throw error;
    }
  }
  const selectedAccount = account || anonymousAccount || newAnonymousAccount;
  return selectedAccount;
}
